export const CATEGORY_DISCOUNT_LIST_REQUEST = "CATEGORY_DISCOUNT_LIST_REQUEST";
export const CATEGORY_DISCOUNT_LIST_SUCCESS = "CATEGORY_DISCOUNT_LIST_SUCCESS";
export const CATEGORY_DISCOUNT_LIST_FAIL = "CATEGORY_DISCOUNT_LIST_FAIL";
